import ErrorBoundaryWithLogger from 'components/common/ErrorBoundary/ErrorBoundary';
import { useAppSelector } from 'store/store';
import {
  footerTaxoLinkColumnsSelector,
  storeIdentifierNameSelector,
  footerClientLoadingSelector,
} from 'store/selectors';
import { StoreIdentifierName } from 'types';
import FooterLinks from './FooterLinks';

const FooterLinksContainer = () => {
  const storeIdentifierName = useAppSelector(storeIdentifierNameSelector);
  const columns = useAppSelector(footerTaxoLinkColumnsSelector);
  const isLoading = useAppSelector(footerClientLoadingSelector);

  if (!columns && isLoading) {
    return null;
  }

  if (!columns) {
    throw Error(
      'Homr did not return any "Footer Links" csvData content. Make sure the correct data is being returned!',
    );
  }
  return (
    <ErrorBoundaryWithLogger componentId="FooterPL-FooterLinks">
      <FooterLinks
        footerLinksData={columns}
        storeIdentifierName={storeIdentifierName as StoreIdentifierName}
      />
    </ErrorBoundaryWithLogger>
  );
};

export default FooterLinksContainer;
